import styled from '@emotion/styled';
import { FC, Fragment } from 'react';

import UserIcon from '@/assets/icons/ic-user.svg';

import { getInitials } from '@/utils/helperFunctions';

const Wrapper = styled.div<{ size: number; imgUrl: string }>`
  border-radius: 50%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #ccc;
  min-width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  font-size: ${({ size }) => size / 2}px;
  background-image: url(${({ imgUrl }) => imgUrl});
  background-position: center center;
  background-size: cover;
`;

interface IAvatarProps {
  imgUrl?: string;
  nameToDisplay?: string;
  size?: number;
}

export const Avatar: FC<IAvatarProps> = ({ imgUrl, nameToDisplay, size = 20, ...restProps }) => {
  const renderInitals = () => {
    const initials = getInitials(nameToDisplay);

    return initials.split('').map((letter, index) => <span key={index}>{letter}</span>);
  };

  const renderContent = () => {
    if (imgUrl) {
      return '';
    }
    if (nameToDisplay) {
      return <Fragment>{renderInitals()}</Fragment>;
    }

    return <UserIcon />;
  };

  return (
    <Wrapper size={size} imgUrl={imgUrl} {...restProps}>
      {renderContent()}
    </Wrapper>
  );
};
